// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

const baseQuery = fetchBaseQuery({
  baseUrl: API_RESSOURCES,
  prepareHeaders: (headers) => {
    headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
    headers.set("Pragma", "no-cache");
    headers.set("Expires", "0");

    return headers;
  },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 3 });

// Define a service using a base URL and expected endpoints
export const activitiesApi = createApi({
  reducerPath: "activitiesApi",
  baseQuery: baseQueryWithRetry,
  tagTypes: ["POST"],
  endpoints: (builder) => ({
    addPosts: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: "/posts",
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data;",
          },
          body: { body },
          formData: true,
        };
      },
    }),
    addComments: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: "/posts/comment",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["POST"],
    }),
    getPosts: builder.query<any, string>({
      query: (userId) => {
        return {
          url: `/posts?profId=&page=1&content=&userId=${userId}`,
          method: "GET",
        };
      },
      providesTags: ["POST"],
    }),
    getComments: builder.mutation<any, string>({
      query: (idPost) => {
        return {
          url: `/posts/${idPost}/comments/find?page=1`,
          method: "GET",
        };
      },
    }),
    postLike: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/posts/like`,
          method: "POST",
          body,
        };
      },
    }),
    postDisLike: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `posts/dislike`,
          method: "POST",
          body,
        };
      },
    }),
    commentLike: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/posts/comments/like`,
          method: "POST",
          body,
        };
      },
    }),
    commentDisLike: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `posts/comments/dislike`,
          method: "POST",
          body,
        };
      },
    }),
    undoCommentLike: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/posts/comments/like/undo`,
          method: "POST",
          body,
        };
      },
    }),
    undoCommentDisLike: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `posts/comments/dislike/undo`,
          method: "POST",
          body,
        };
      },
    }),
    getPostsCounts: builder.query<any, string>({
      query: () => {
        return {
          url: `/posts/static/docs/count`,
          method: "GET",
        };
      }
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddPostsMutation,
  useGetPostsQuery,
  useAddCommentsMutation,
  useGetCommentsMutation,
  usePostLikeMutation,
  usePostDisLikeMutation,
  useCommentLikeMutation,
  useCommentDisLikeMutation,
  useUndoCommentLikeMutation,
  useUndoCommentDisLikeMutation,
  useGetPostsCountsQuery,
} = activitiesApi;
